/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Mcp_Errors_TitleInputs */

const en_directory_mcp_errors_title = /** @type {(inputs: Directory_Mcp_Errors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errors`)
};

const zh_directory_mcp_errors_title = /** @type {(inputs: Directory_Mcp_Errors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错误处理`)
};

/**
* | output |
* | --- |
* | "Errors" |
*
* @param {Directory_Mcp_Errors_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_mcp_errors_title = /** @type {((inputs?: Directory_Mcp_Errors_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Mcp_Errors_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_mcp_errors_title(inputs)
	return zh_directory_mcp_errors_title(inputs)
});
export { directory_mcp_errors_title as "directory.mcp.errors_title" }